import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Path } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Path>()

export function TablePaths({
  paths,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  paths: Path[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!paths) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [paths, count])
  return (
    <Table
      data={paths}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Titolo"
        name="title"
        sortable
        width="minmax(max-content, 1fr)"
        render={(path) => (
          <Link to={`/paths/paths/${path.id}`}>
            <LinkMagik className="text-dark">{path.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />

      <Table.Column
        title="Tema"
        name="theme__name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(path) => {
          return path.theme_data?.name || "-"
        }}
      />

      <Table.Column
        title="Autore"
        name="author__name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(path) => {
          return path.author_data?.name || "-"
        }}
      />

      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="minmax(max-content, 1fr)"
        render={(path) => {
          return path.order
        }}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} percorsi
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
